var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@web/components/layout/Button';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { widgetMetricCellBadgeDiff, widgetMetricCellDurationText, widgetMetricCellThreeColDiff, widgetMetricTableDiffTdClass, widgetMetricTableDurationSlashClass, widgetMetricTableFigureValueSpanHugClass, widgetMetricTablePairHeaderThAlignBodyTdClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerFitClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import BadgeDiff from '@web/components/ui/Badge/BadgeDiff';
import { TablesDiffColorsConfig } from '@web/config';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { trpc } from '@web/lib/trpc';
import { classNames, getApplicationIconByType, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { navigateToEventsLogForActivityLabel } from '@web/utility/chartNavigation';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ApplicationEnum } from '@workalizer/shared';
import { WIDGET_TABLE_INITIAL_ROWS, WIDGET_TABLE_LOAD_MORE_ROWS } from '@workalizer/shared/config';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { sliceRowsKeepingUncategorizedLast, uncategorizedLast } from '@workalizer/shared/utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
var workingTimeAllocationCountDurationRowClass = 'inline-flex w-fit max-w-full min-w-0 flex-nowrap items-baseline justify-start gap-x-1 pl-0 pr-0';
var workingTimeAllocationStackedDiffsClass = 'flex shrink-0 flex-col items-start gap-0.5';
var workingTimeAllocationValueTdClass = widgetMetricTableValueTdClass.replace('align-top', '!align-middle');
var workingTimeAllocationDiffTdClass = widgetMetricTableDiffTdClass.replace('align-top', '!align-middle');
function workingTimeAllocationByLabelTableColgroup() {
    var countDurationValueCol = {
        width: '10%',
        minWidth: '11.5rem'
    };
    var diffCol = { width: '6%', minWidth: '5.5rem' };
    var metricValueCol = { width: '5%', minWidth: '2.75rem' };
    return [
        { width: '18%', minWidth: '10.5rem' },
        countDurationValueCol,
        diffCol,
        countDurationValueCol,
        diffCol,
        countDurationValueCol,
        diffCol,
        metricValueCol,
        diffCol
    ];
}
var METRIC_HEADINGS = [
    {
        app: ApplicationEnum.MEET,
        i18nKey: 'app.performanceReview.employeePerformanceReview.timeManagementSection.tablesData.meetings'
    },
    {
        app: ApplicationEnum.DRIVE,
        i18nKey: 'app.performanceReview.employeePerformanceReview.timeManagementSection.tablesData.documents'
    },
    {
        app: ApplicationEnum.CHAT,
        i18nKey: 'app.performanceReview.employeePerformanceReview.timeManagementSection.tablesData.chatMessage'
    },
    {
        app: ApplicationEnum.CALENDAR,
        i18nKey: 'app.performanceReview.employeePerformanceReview.timeManagementSection.tablesData.events'
    }
];
var WorkingTimeAllocationStackedDiffs = function (_a) {
    var metric = _a.metric, showTeamDiff = _a.showTeamDiff, isSecondaryDiffHidden = _a.isSecondaryDiffHidden;
    var showPeriodBadge = (metric === null || metric === void 0 ? void 0 : metric.prevPeriodDiff) != null;
    var showTeamBadge = showTeamDiff && !isSecondaryDiffHidden && (metric === null || metric === void 0 ? void 0 : metric.teamAvgDiff) != null;
    if (showPeriodBadge &&
        showTeamBadge &&
        (metric === null || metric === void 0 ? void 0 : metric.prevPeriodDiff) &&
        (metric === null || metric === void 0 ? void 0 : metric.teamAvgDiff)) {
        return (_jsx("div", __assign({ className: "flex w-full min-w-0 justify-start pl-0 pr-0" }, { children: _jsxs("div", __assign({ className: workingTimeAllocationStackedDiffsClass }, { children: [_jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: _jsx(BadgeDiff, { diffValue: metric.prevPeriodDiff, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.GREEN }) })), _jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: _jsx(BadgeDiff, { diffValue: metric.teamAvgDiff, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.BLUE }) }))] })) })));
    }
    if (showPeriodBadge && (metric === null || metric === void 0 ? void 0 : metric.prevPeriodDiff)) {
        return (_jsx("div", __assign({ className: "flex w-full min-w-0 justify-start pl-0 pr-0" }, { children: _jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: _jsx(BadgeDiff, { diffValue: metric.prevPeriodDiff, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.GREEN }) })) })));
    }
    if (showTeamBadge && (metric === null || metric === void 0 ? void 0 : metric.teamAvgDiff)) {
        return (_jsx("div", __assign({ className: "flex w-full min-w-0 justify-start pl-0 pr-0" }, { children: _jsx("div", __assign({ className: widgetMetricCellThreeColDiff }, { children: _jsx(BadgeDiff, { diffValue: metric.teamAvgDiff, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.BLUE }) })) })));
    }
    return null;
};
function buildWorkingTimeAllocationMetricCells(columnId, labelId, metric, variant, userId, isSecondaryDiffHidden, onValueClick) {
    var showTeamDiff = Boolean(userId);
    var durationText = variant === 'countDuration' &&
        (metric === null || metric === void 0 ? void 0 : metric.duration) != null &&
        metric.duration !== ''
        ? String(metric.duration)
        : '';
    return [
        {
            id: "".concat(columnId, "-value-").concat(labelId),
            className: classNames(workingTimeAllocationValueTdClass, 'cursor-pointer'),
            render: function () {
                var _a, _b;
                return variant === 'countDuration' ? (_jsxs("div", __assign({ className: classNames(workingTimeAllocationCountDurationRowClass, 'cursor-pointer'), onClick: onValueClick }, { children: [_jsx("span", __assign({ className: classNames(widgetMetricTableFigureValueSpanHugClass, 'shrink-0') }, { children: (_a = metric === null || metric === void 0 ? void 0 : metric.count) !== null && _a !== void 0 ? _a : 0 })), _jsx("span", __assign({ className: classNames(widgetMetricTableDurationSlashClass, 'shrink-0'), "aria-hidden": "true" }, { children: "/" })), _jsx("span", __assign({ className: widgetMetricCellDurationText }, { children: durationText }))] }))) : (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerFitClass, 'cursor-pointer'), onClick: onValueClick }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanHugClass }, { children: (_b = metric === null || metric === void 0 ? void 0 : metric.count) !== null && _b !== void 0 ? _b : 0 })) })));
            }
        },
        {
            id: "".concat(columnId, "-diff-").concat(labelId),
            className: workingTimeAllocationDiffTdClass,
            render: function () { return (_jsx(WorkingTimeAllocationStackedDiffs, { metric: metric, showTeamDiff: showTeamDiff, isSecondaryDiffHidden: isSecondaryDiffHidden })); }
        }
    ];
}
export var WorkingTimeAllocationByLabel = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo, _b = _a.isSecondaryDiffHidden, isSecondaryDiffHidden = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _c = useWorkspaceCtx(), workspaceLabels = _c.labels, isWorkspaceLoading = _c.isLoading;
    var _d = useState(WIDGET_TABLE_INITIAL_ROWS), displayedCount = _d[0], setDisplayedCount = _d[1];
    var _e = trpc.workingTimeAllocationByLabel.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        labelIds: workspaceLabels.map(function (label) { return label.id; })
    }, { enabled: !isWorkspaceLoading }), data = _e.data, isLoading = _e.isLoading, refetch = _e.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var orderedRows = uncategorizedLast(data !== null && data !== void 0 ? data : [], function (r) { return r.labelId === null; });
    var _f = sliceRowsKeepingUncategorizedLast(orderedRows, displayedCount, function (r) { return r.labelId === null; }), displayedRows = _f.displayedRows, hasMore = _f.hasMore;
    var metricHeaderColspan = 2;
    var headerMetricClass = widgetMetricTablePairHeaderThAlignBodyTdClass;
    var columns = __spreadArray([
        {
            title: t('app.performanceReview.employeePerformanceReview.timeManagementSection.tablesData.label'),
            isVisible: true,
            className: 'min-w-[10.5rem] sm:min-w-0 !text-left !pl-3 !pr-4 whitespace-normal'
        }
    ], METRIC_HEADINGS.map(function (_a) {
        var app = _a.app, i18nKey = _a.i18nKey;
        return ({
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [getApplicationIconByType(app), _jsx("span", { children: t(i18nKey) })] }))),
            isVisible: true,
            colspan: metricHeaderColspan,
            className: headerMetricClass
        });
    }), true);
    var rowByLabelId = new Map(orderedRows.map(function (item) { return [item.labelId, item]; }));
    var getLabelDisplayName = function (labelId, labelName) {
        return labelId === null
            ? t('app.performanceReview.employeePerformanceReview.uncategorized')
            : labelName;
    };
    var navigateToLabelEventsLog = function (labelId, app) {
        if (app === void 0) { app = null; }
        navigateToEventsLogForActivityLabel({
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId,
            activityLabelId: labelId,
            app: app
        });
    };
    var renderRow = function (labelId, labelName) {
        var labelData = rowByLabelId.get(labelId);
        var onLabelClick = function () { return navigateToLabelEventsLog(labelId); };
        var onMeetingsClick = function () {
            return navigateToLabelEventsLog(labelId, ApplicationEnum.MEET);
        };
        var onDocumentsClick = function () {
            return navigateToLabelEventsLog(labelId, ApplicationEnum.DRIVE);
        };
        var onChatClick = function () {
            return navigateToLabelEventsLog(labelId, ApplicationEnum.CHAT);
        };
        var onEventsClick = function () {
            return navigateToLabelEventsLog(labelId, ApplicationEnum.CALENDAR);
        };
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
            {
                id: "label-".concat(labelId),
                className: classNames(widgetMetricTablePrimaryLabelTdClass, 'min-w-[10.5rem] sm:min-w-0 whitespace-normal !pr-4 cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: "w-full min-w-[9rem] cursor-pointer font-semibold break-words sm:min-w-0", onClick: onLabelClick }, { children: labelName }))); }
            }
        ], buildWorkingTimeAllocationMetricCells('meetings', labelId, labelData === null || labelData === void 0 ? void 0 : labelData.meetings, 'countDuration', userId, isSecondaryDiffHidden, onMeetingsClick), true), buildWorkingTimeAllocationMetricCells('documents', labelId, labelData === null || labelData === void 0 ? void 0 : labelData.documents, 'countDuration', userId, isSecondaryDiffHidden, onDocumentsClick), true), buildWorkingTimeAllocationMetricCells('chat', labelId, labelData === null || labelData === void 0 ? void 0 : labelData.chatMessages, 'countDuration', userId, isSecondaryDiffHidden, onChatClick), true), buildWorkingTimeAllocationMetricCells('events', labelId, labelData === null || labelData === void 0 ? void 0 : labelData.events, 'count', userId, isSecondaryDiffHidden, onEventsClick), true);
    };
    var tableData = displayedRows.map(function (item) {
        return renderRow(item.labelId, getLabelDisplayName(item.labelId, item.labelName));
    });
    return (_jsxs("div", __assign({ className: "w-full min-w-0" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.timeManagementSection.workingTimeAllocationByLabel'), description: t('widgetTitleDescriptions.timeManagement.workingTimeAllocationByLabel'), insightType: InsightTypeEnum.workingTimeAllocationByLabel, insightsData: orderedRows, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.timeManagementSection.workingTimeAllocationByLabel'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, orderedRows.map(function (item) {
                                    var _a;
                                    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
                                    var labelName = getLabelDisplayName(item.labelId, item.labelName);
                                    var meetDisplay = ((_b = item.meetings) === null || _b === void 0 ? void 0 : _b.duration)
                                        ? "".concat((_d = (_c = item.meetings) === null || _c === void 0 ? void 0 : _c.count) !== null && _d !== void 0 ? _d : 0, "\n").concat(item.meetings.duration)
                                        : String((_f = (_e = item.meetings) === null || _e === void 0 ? void 0 : _e.count) !== null && _f !== void 0 ? _f : 0);
                                    var documentsDisplay = ((_g = item.documents) === null || _g === void 0 ? void 0 : _g.duration)
                                        ? "".concat((_j = (_h = item.documents) === null || _h === void 0 ? void 0 : _h.count) !== null && _j !== void 0 ? _j : 0, "\n").concat(item.documents.duration)
                                        : String((_l = (_k = item.documents) === null || _k === void 0 ? void 0 : _k.count) !== null && _l !== void 0 ? _l : 0);
                                    var chatDisplay = ((_m = item.chatMessages) === null || _m === void 0 ? void 0 : _m.duration)
                                        ? "".concat((_p = (_o = item.chatMessages) === null || _o === void 0 ? void 0 : _o.count) !== null && _p !== void 0 ? _p : 0, "\n").concat(item.chatMessages.duration)
                                        : String((_r = (_q = item.chatMessages) === null || _q === void 0 ? void 0 : _q.count) !== null && _r !== void 0 ? _r : 0);
                                    return _a = {},
                                        _a[t('app.performanceReview.employeePerformanceReview.timeManagementSection.tablesData.label')] = labelName,
                                        _a[t('app.performanceReview.employeePerformanceReview.timeManagementSection.tablesData.meetings')] = meetDisplay,
                                        _a[t('app.performanceReview.employeePerformanceReview.timeManagementSection.tablesData.documents')] = documentsDisplay,
                                        _a[t('app.performanceReview.employeePerformanceReview.timeManagementSection.tablesData.chatMessage')] = chatDisplay,
                                        _a[t('app.performanceReview.employeePerformanceReview.timeManagementSection.tablesData.events')] = (_t = (_s = item.events) === null || _s === void 0 ? void 0 : _s.count) !== null && _t !== void 0 ? _t : 0,
                                        _a;
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(orderedRows) }) }), _jsx(Table, { columns: columns, data: isInsightsDataEmpty(orderedRows) ? [] : tableData, columnColStyles: workingTimeAllocationByLabelTableColgroup(), tableClassName: classNames('w-full table-auto', 'min-w-[72rem]'), rowClassName: "[&>td:first-child]:align-top [&>td:not(:first-child)]:align-middle" }), hasMore && (_jsx("div", __assign({ className: "mt-4 flex justify-center" }, { children: _jsx(Button, __assign({ variant: "link", onClick: function () {
                        return setDisplayedCount(function (prev) { return prev + WIDGET_TABLE_LOAD_MORE_ROWS; });
                    } }, { children: t('loadMore') })) })))] })));
};
